import { useBoolState, useFn } from '@eturi/react'
import { useT } from '@eturi/react-i18next'
import { isInstallingChildApp$, requestInstallChildApp } from '@op/app-shared'
import { unwrapThunk } from '@op/services'
import { useEffect, useState } from 'react'
import { disabledProps } from '../../common'
import { commons } from '../../ghetto-commons'
import { useAppDispatch, useTypedSelector } from '../../types'
import { Btn, InfoModal, useToasts } from '../../widgets'

type ChildAppInstallBtnProps = {
	readonly childId: string
	readonly className?: string
	readonly deviceId: string
	readonly disabled?: boolean
}

export const ChildAppInstallBtn = ({
	childId,
	className = '',
	deviceId,
	disabled = false,
}: ChildAppInstallBtnProps) => {
	const d = useAppDispatch()
	const [t] = useT()
	const { addErrorToast } = useToasts()
	const isInstallingChildApp = useTypedSelector((s) =>
		isInstallingChildApp$(s, { deviceId, userId: childId }),
	)
	const [isInstallModalVisible, showInstallModal, hideInstallModal] = useBoolState(false)
	// The only purpose of this is to show the user that "something happened" after they close the
	// install modal. We could just remove this and let them click the button repeatedly, but that
	// lacks feedback.
	const [isBtnDisabledViaInstall, setBtnDisabledViaInstall] = useState(false)

	const isBtnDisabled = disabled || isBtnDisabledViaInstall

	const handleInstallChildAppClick = useFn(async () => {
		if (isInstallingChildApp) {
			showInstallModal()
			setBtnDisabledViaInstall(true)
		}

		try {
			await unwrapThunk(d(requestInstallChildApp({ deviceId, userId: childId })))
		} catch {
			setBtnDisabledViaInstall(false)
			addErrorToast(t('error_strings.install_child_app_error'))
		}
	})

	useEffect(() => {
		if (!isInstallModalVisible) setBtnDisabledViaInstall(false)
	}, [isInstallingChildApp])

	return (
		<>
			<Btn {...disabledProps(isBtnDisabled, className)} onClick={handleInstallChildAppClick}>
				<span className="btn-img-wrapper">
					{t('actions.install_child_app')}
					<img
						className="bg-white"
						src={commons.OPJ_LOGO_MANGLE$$}
						alt="OurPact Jr."
						title="OurPact Jr."
					/>
				</span>
			</Btn>

			{isInstallModalVisible && (
				<InfoModal
					header={t('devices.child_app_installed_modal.header')}
					onClose={hideInstallModal}
				>
					<p>{t('devices.child_app_installed_modal.description')}</p>

					<InfoModal.Footer>
						<Btn onClick={hideInstallModal}>{t('actions.ok')}</Btn>
					</InfoModal.Footer>
				</InfoModal>
			)}
		</>
	)
}
